import { render, staticRenderFns } from "./bookings.vue?vue&type=template&id=51a49acc"
import script from "./bookings.vue?vue&type=script&lang=js"
export * from "./bookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports